import { render, staticRenderFns } from "./AddPupilDialog.vue?vue&type=template&id=6a627094"
import script from "./AddPupilDialog.vue?vue&type=script&lang=ts"
export * from "./AddPupilDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports